import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },

        {
            name: 'Courses',
            route: 'courses',
            children: [
                { name: 'Courses', route: 'courses', type: 'course' },
                { name: 'Bookings/Orders', route: 'orders', type: 'order' },
                { name: 'Attendees', route: 'course_attendees', type: 'course_attendee' },
            ],
            iconClass: 'material-icons',
            iconName: 'book_open',
            color: 'navy',
            group: 'Education',
            iconComponent: FeatherIcons.BookOpenIcon,
        },
         {
            name: 'Faculty',
            route: 'faculty',
            type: 'faculty',
            iconClass: 'kt-menu__link-icon flaticon2-chat-2',
            // iconName: '',
            color: 'navy',
            group: 'Education',
            iconComponent: FeatherIcons.UserIcon,
        },

        {
            group: 'Media',
            name: 'Publications',
            route: 'publications',
            iconClass: 'material-icons',
            iconName: 'bookmark',
            color: 'navy',
            iconComponent: FeatherIcons.BookmarkIcon,
        },

        {
            group: 'Media',
            name: 'Links',
            route: 'links',
            iconClass: 'material-icons',
            iconName: 'link_external',
            color: 'navy',
            iconComponent: FeatherIcons.ExternalLinkIcon,
        },
        {
            group: 'Media',
            name: 'Knowledge and Skills',
            route: 'skills',
            iconClass: 'material-icons',
            iconName: 'sentiment_satisfied_alt',
            color: 'navy',
            iconComponent: FeatherIcons.UsersIcon,
        },


        // {
        //     name: 'Video',
        //     children: [
        //         { name: 'Videos', route: 'videos', type: 'videos' },
        //     ],
        //     color: 'navy',
        //     group: 'media',
        //     iconComponent: FeatherIcons.VideoIcon,
        // },
        // {
        //     group: 'media',
        //     name: 'Galleries',
        //     route: 'galleries',
        //     iconClass: 'material-icons',
        //     color: 'navy',
        //     iconComponent: FeatherIcons.ImageIcon,
        // },

        // {
        //     name: 'Customers',
        //     ...{ name: 'Customers', route: 'customers', type: 'customer' },
        //     color: 'navy',
        //     group: 'client',
        //     iconComponent: FeatherIcons.UsersIcon,
        // },
        {
            name: 'Enquiries',
            route: 'enquiries', type: 'enquiry',
            // children: [
                // { name: 'All Enquiries', route: 'enquiries', type: 'enquiry' },
                // { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            // ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
       /*  {
            name: 'Reports',
            children: [
                { name: 'Search Log', route: 'search_log' },
                { name: 'Customer Logins', route: 'customer_login_logs' },
                { name: 'Customer Favourites', route: 'customers_listings' },
            ],
            color: 'navy',
            group: 'reports',
            iconComponent: FeatherIcons.BarChart2Icon,
        }, */
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users' },
                { name: 'Roles', route: 'roles' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
